import React from 'react'
import { Content, DefaultLayout } from '../layouts'
import { H2, P } from '@mote/ui'

export const WebinarsScreen = () => {
  return (
    <DefaultLayout>
      <Content>
        <H2>
          Join a webinar and raise your{' '}
          <span className='mote-purple'>Mote</span> game!
        </H2>
        <P>Schedule of upcoming events - click the links to sign up!</P>
        <iframe
          title='Webinars'
          className='airtable-embed'
          src='https://airtable.com/embed/shr00o5BfoX5qyp50?backgroundColor=teal&viewControls=on'
          frameborder='0'
          onmousewheel=''
          width='100%'
          height='1700'
          styleName='background: transparent; border: 1px solid #ccc'
        />
      </Content>
    </DefaultLayout>
  )
}
